import { Props } from './props'

export const mobileWidth = function (captchaWidth: number) {
  return function ({ columns }: Props) {
    return columns === 1 ? captchaWidth : 'initial'
  }
}
